import { ITableColumn } from '@/uikit/table/NTable.vue';
import NText from '@/uikit/text/NText.vue';
import CardOrUnmatched from '@/pages/external-search/CardOrUnmatched.vue';
import ExternalSearchRequestActions from '@/pages/external-search/requests/ExternalSearchRequestActions.vue';
import ExternalSearchRequestInfo from '@/pages/external-search/requests/ExternalSearchRequestInfo.vue';

export const externalSearchRequestsTableSchema: ITableColumn[] = [
  {
    width: 'minmax(160px, auto)',
    header: {},
    content: {
      component: ExternalSearchRequestInfo,
      props: (item: any) => ({ item: item }),
      on: {
        action: function (this: any, action: string) {
          const item = this.item;
          this.tableCell.$emit('action', { item, action });
        }
      }
    }
  },
  {
    width: 'minmax(300px, auto)',
    header: {},
    content: {
      name: 'card',
      component: CardOrUnmatched,
      props: (item: any) => ({ item: item.cardObject, deleted: item.is_deleted }),
      on: {
        'display-card-image'(this: any, src: string) {
          this.tableCell.$emit('action', { item: this.item, action: 'fullframe', src });
        }
      }
    }
  },
  {
    width: 'minmax(100px, auto)',
    header: {},
    content: {
      path: 'reason',
      component: NText,
      props: {
        class: 'label-xs'
      }
    }
  },
  {
    width: 'minmax(80px, auto)',
    header: {},
    content: {
      component: ExternalSearchRequestActions,
      props: (item: any) => ({ item: item }),
      on: {
        action: function (this: any, action: string) {
          const item = this.item;
          this.tableCell.$emit('action', { item, action });
        }
      }
    }
  }
];
